import type { FC } from 'react';

import classNames from 'classnames';

import Ellipsis from '../ellipsis/ellipsis';
import UserBubble from '../user_bubble/user_bubble';

import styles from './user_item.module.css';

type Props = {
  fullName: string;
  annotation?: string;
  photo?: string;
  wrap?: boolean;
};

const UserItem: FC<Props> = (props) => (
  <div className={classNames(styles.root, { wrap: props.wrap })}>
    <div className={styles.avatar}>
      <UserBubble src={props.photo} size="sm" name={props.fullName} />
    </div>
    <Ellipsis componentProps={{ className: styles.name }}>
      {props.fullName} {props.annotation && <span>{props.annotation}</span>}
    </Ellipsis>
  </div>
);

export default UserItem;
